// tasksData.js
// Ces données peuvent être placées dans un fichier distinct ou directement dans le composant parent

export const tasksData = [
    // Mes propres tâches (créées par moi pour moi)
    {
      id: 1,
      text: "Préparer les fiches de paie pour le mois de mai",
      status: "todo", // todo, inProgress, done
      createdAt: "2025-04-25T10:30:00",
      createdBy: 1, // ID de l'utilisateur qui a créé la tâche (Sophie Ndiaye)
      assignedTo: 1, // ID de l'utilisateur assigné (Sophie Ndiaye)
      archived: false
    },
    {
      id: 2,
      text: "Entretien de recrutement avec candidat pour poste d'enseignant",
      status: "inProgress",
      createdAt: "2025-04-26T09:15:00",
      createdBy: 1, // Sophie Ndiaye
      assignedTo: 1, // Sophie Ndiaye
      archived: false
    },
    
    // Tâches que j'ai attribuées à d'autres
    {
      id: 3,
      text: "Vérifier les demandes de congés en attente",
      status: "todo",
      createdAt: "2025-04-27T14:00:00",
      createdBy: 1, // Sophie Ndiaye
      assignedTo: 3, // Aminata Kone
      archived: false
    },
    {
      id: 4,
      text: "Mise à jour des contrats du personnel administratif",
      status: "done",
      createdAt: "2025-04-20T11:30:00",
      createdBy: 1, // Sophie Ndiaye
      assignedTo: 2, // Mohamed Diallo
      archived: false
    },
    
    // Tâches qui me sont attribuées par d'autres
    {
      id: 5,
      text: "Planifier la formation Excel pour les nouveaux employés",
      status: "todo",
      createdAt: "2025-04-27T16:45:00",
      createdBy: 4, // Jean Koffi
      assignedTo: 1, // Sophie Ndiaye
      archived: false
    },
    {
      id: 6,
      text: "Finaliser le plan d'évaluation du personnel pour le trimestre",
      status: "inProgress",
      createdAt: "2025-04-24T13:20:00",
      createdBy: 2, // Mohamed Diallo
      assignedTo: 1, // Sophie Ndiaye
      archived: false
    },
    
    // Tâche archivée
    {
      id: 7,
      text: "Organiser la réunion d'équipe mensuelle",
      status: "done",
      createdAt: "2025-04-15T10:00:00",
      createdBy: 1, // Sophie Ndiaye
      assignedTo: 1, // Sophie Ndiaye
      archived: true
    }
  ];
  
  // Exemple de données utilisateurs pour l'assignation des tâches
  export const usersData = [
    {
      id: 1,
      name: "Sophie Ndiaye",
      role: "Responsable RH"
    },
    {
      id: 2,
      name: "Mohamed Diallo",
      role: "Assistant RH"
    },
    {
      id: 3,
      name: "Aminata Kone",
      role: "Gestionnaire de paie"
    },
    {
      id: 4,
      name: "Jean Koffi",
      role: "Recruteur"
    }
  ];